import { render, staticRenderFns } from "./InputElement.vue?vue&type=template&id=94453230&scoped=true&"
import script from "./InputElement.vue?vue&type=script&lang=js&"
export * from "./InputElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94453230",
  null
  
)

export default component.exports